/// <reference path="../../app.ts" />
namespace Cfnc {
    interface IcfncApplyToSchool extends ng.IDirective {
        replace: boolean;
        restrict: string;
        transclude: boolean;
        template: string;
    }

    interface IcfncApplyToSchoolScope extends ng.IScope {
        open: () => void;
        schoolid: string;
        modalClosed: (value) => void;
    }

    interface IcfncApplyToSchoolAttributes extends ng.IAttributes {
        modalClosed: void

    }

    class cfncApplyToSchool implements IcfncApplyToSchool {
        static directiveId: string = "cfncApplyToSchool";
        replace: boolean = true;
        restrict: string = "E";
        transclude: boolean = true;
        parentScope: IcfncApplyToSchoolScope;
        scope: any = {
            schoolid: "=",
            modalClosed: "="
        };



        template: string = "<a ng-click='open()'><ng-transclude></ng-transclude></a>";

        link = (scope: IcfncApplyToSchoolScope, element, attrs: IcfncApplyToSchoolAttributes) => {
            scope.open = () => {
                this.common.authentication.authenticate(true).then(result => {
                    if (result) {
                        var modalInstance = this.$uibModal.open({
                            templateUrl: '/app/directives/cfncApplyToSchool/startNewAppModal.html',
                            controller: 'startNewAppModal',
                            size: "lg",
                            backdrop: "static",
                            resolve: {
                                schoolid: function () {
                                    return scope.schoolid;
                                }
                            }
                        });
                        modalInstance.result.then((result) => {
                            if (scope.modalClosed) {
                                scope.modalClosed.call(scope.$parent, result.window);
                            }
                        });
                    }
                    else {

                        this.startApplicationService.schoolId = scope.schoolid;

                    }
                });


            }


            if (this.startApplicationService.schoolId) {
                scope.schoolid = _.clone(this.startApplicationService.schoolId);
                this.startApplicationService.clear();
                scope.open();
            }



        }

        constructor(private $uibModal: ng.ui.bootstrap.IModalService, private common: ICommonFactory, private startApplicationService: IStartApplicationService) {
        }


    }

    angular.module("app").directive(cfncApplyToSchool.directiveId, ["$uibModal", "common", "startApplicationService", ($uibModal: ng.ui.bootstrap.IModalService, common: ICommonFactory, startApplicationService: IStartApplicationService) =>
        new cfncApplyToSchool($uibModal, common, startApplicationService)
    ]);

}
